import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhoneAlt, FaClock, FaFacebookF, FaTwitter, FaYoutube, FaLinkedinIn, FaFax } from 'react-icons/fa';
import Footer from '../components/Footer';

const ContactUs = () => {
  return (
    <div style={{ marginTop: '150px' }}>
 <Container className="text-center mb-5">
  <h1 style={{ color: 'red', marginBottom: '30px' }}>Contact Us</h1>
  
  {/* Location and Contact Info */}
  <Row className="justify-content-center mb-5">
    <Col md={6} className="text-center">
      <h4 style={{ color: 'red' }}>
        <FaMapMarkerAlt /> Our Location
      </h4>
      <p>Lin's Bistro</p>
      <p>1880 Braselton Hwy, Suite 122, <br /> Lawrenceville, GA 30043</p>
      <p><FaPhoneAlt /> (770) 338-2887</p>
      <p><FaFax /> Fax: (770) 338-8978</p>
    </Col>
  </Row>

  {/* Opening Hours */}
  <Row className="justify-content-center">
    <Col md={6} className="text-center">
      <h4 style={{ color: 'red' }}>
        <FaClock /> Opening Times
      </h4>
      <ul className="list-unstyled">
        <li>Monday: Closed</li>
        <li>Tuesday - Thursday: 11:00 am - 9:30 pm</li>
        <li>Friday: 11:00 am - 10:00 pm</li>
        <li>Saturday: 11:30 am - 10:00 pm</li>
        <li>Sunday: 11:30 am - 9:30 pm</li>
      </ul>
    </Col>
  </Row>
</Container>



      {/* Custom Styles */}
      <style jsx>{`
        h1, h4 {
          font-weight: bold;
        }
        ul {
          padding-left: 0;
        }
        li {
          font-size: 1.1rem;
        }
      `}</style>
            <Footer />

    </div>
  );
};

export default ContactUs;
